import { render } from "./IconRack.vue?vue&type=template&id=b86cc0fe"
import script from "./IconRack.vue?vue&type=script&lang=ts"
export * from "./IconRack.vue?vue&type=script&lang=ts"
script.render = render

export default script